module.exports = __webpack_public_path__ + "img/webece2.ef8619c7.jpg";